import { Injectable } from '@angular/core';
import { File } from '@ionic-native/file';
import { HttpProvider } from '../http/http';
import { APP_CONFIG } from '../../environment';

@Injectable()
export class ReceiptProvider {
  authToken: string;
  constructor(private httpProvider: HttpProvider,
              private file: File) {
  }

  /**
   * @description Gets the receipt file response for a newly created order.
   */
  getNewOrderReceipt(orderNumber: string): Promise<any> {
    return this.httpProvider.downloadFile(`${APP_CONFIG.remittanceApiBaseUrl}order/${orderNumber}/receipt`, {}, `${this.file.dataDirectory}Ria-order-receipt-${orderNumber}.pdf`);
  }

  getOrderReceipt(orderNumber: string): Promise<any> {
    return this.httpProvider.downloadFile(`${APP_CONFIG.remittanceApiBaseUrl}order/${orderNumber}/receipt/reprint`, {}, `${this.file.dataDirectory}Ria-order-receipt-${orderNumber}.pdf`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/receipt/receipt.ts